export const EVENT_TRIGGERS_BETA_SURVEY_ID = 753;